import React, { useMemo, useContext } from 'react';
import Slider from 'rc-slider';
import PricingContext from '../../../context/pricing';
import { dataLayerPush } from '../../../utils';
import {
  StyledPlanSlider,
  StyledMinMaxLabels,
  StyledSliderSubText,
} from './styles';

const PlanSlider = ({
  minLabel,
  maxLabel,
  unit,
  value,
  testid,
  min,
  max,
  name,
  ...sliderProps
}) => {
  const { state, sgPricingVersion } = useContext(PricingContext);

  const handleOnAfterChange = (val) => {
    const sliderType = unit === 'emails/mo' ? 'volume' : unit;
    const data = {
      event: 'pricingFunnel',
      eventAction: 'slider_interaction',
      pricingVersion: sgPricingVersion,
      pricingTab: state.activeTab,
      currentSelection: val,
      sliderType,
      packageInt: name, // of the current slider.
    };
    dataLayerPush(data);
  };

  const marks = useMemo(() => {
    const markObj = {};
    let count = min;
    while (count <= max) {
      markObj[count] = false;
      if (count < 10000) {
        count += 1000;
      } else if (count < 50000) {
        count += 5000;
      } else if (count < 200000) {
        count += 10000;
      } else if (count < 1000000) {
        count += 50000;
      } else {
        count += 100000;
      }
    }
    return markObj;
  }, [min, max]);

  return (
    <StyledPlanSlider data-testid={testid}>
      <StyledMinMaxLabels>
        <span>{minLabel}</span>
        <span>{maxLabel}</span>
      </StyledMinMaxLabels>
      <Slider
        marks={marks}
        step={null}
        min={min}
        max={max}
        value={value}
        onAfterChange={handleOnAfterChange}
        {...sliderProps}
      />
      <StyledSliderSubText>
        {value.toLocaleString()} {unit}
      </StyledSliderSubText>
    </StyledPlanSlider>
  );
};

PlanSlider.defaultProps = {
  min: 0,
  minLabel: 0,
  value: 0,
};

export default PlanSlider;
